import axios from 'axios'
import { motion } from 'framer-motion'
import { useContext, useEffect, useState } from 'react'
import { FiEdit, FiEye, FiTrash2 } from 'react-icons/fi'
import { HiDotsVertical, HiDownload } from 'react-icons/hi'
import { IoCalculatorOutline, IoReceiptOutline } from 'react-icons/io5'
import { MdPeople } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ColumnsTable, IClient, ISuscriber } from 'safe'
import AdvancedSubscribersForm from '../../components/Display/AdvancedSubscribersForm'
import FloatingForm from '../../components/Display/FloatingForm'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { ThemeContext } from '../../context/ThemeContext'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { RootState } from '../../redux/store'
import { onCreateSubscribersExcel } from '../../utils/CreateExcel'
import { dateToDB, transformDate } from '../../utils/utils'
import ClientsForm from '../Clients/ClientsForm'
import { ISuscription } from '../Suscriptions/Suscriptions'
import SubscriberView from './SubscriberView'
import SuscriberForm from './SuscriberForm'

const server = process.env.REACT_APP_SERVER_URL

const Suscribers = ({ setHeaderActions }) => {
  const [subscribers, setSubscribers] = useState<ISuscriber[]>([])

  const [numberOfPages, setNumberOfPages] = useState<number>(0)

  const [currentPage, setCurrentPage] = useState<number>(0)

  const [loading, setLoading] = useState<boolean>(false)

  const [showModal, setShowModal] = useState(false)

  const { addAlert } = useSnackBars()
  const { theme } = useContext(ThemeContext)

  const [suscriptionModal, setSuscriptionModal] = useState<boolean>(false)

  const [suscriptions, setSuscriptions] = useState<ISuscription[]>([])

  const [selectedClient, setSelectedClient] = useState<any | null>(null)

  const [creatingSuscriber, setCreatingSuscriber] = useState<boolean>(false)

  const [menuVisible, setMenuVisible] = useState<number>(-1)

  const [selectedClientToDelete, setSelectedClientToDelete] =
    useState<any | null>(null)

  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const [selectedSubscriptionToDelete, setSelectedSubscriptionToDelete] =
    useState(null)

  const [showEdit, setShowEdit] = useState(false)

  const [selectedSuscriberToEdit, setSelectedSuscriberToEdit] = useState(null)

  const [fastSearch, setFastSearch] = useState<string>('')

  const [modalSearch, setModalSearch] = useState<boolean>(false)

  const [searchParams, setSearchParams] = useState<any>({})

  const [showProrrateModal, setShowProrrateModal] = useState<boolean>(false)

  const [prorrateDays, setProrrateDays] = useState<string>('')

  const [selectedClientForProrate, setSelectedClientForProrate] =
    useState<any | null>(null)

  const [showViewModal, setShowViewModal] = useState<boolean>(false)

  const [selectedSubscriberToView, setSelectedSubscriberToView] =
    useState<ISuscriber | null>(null)

  const dispatch = useDispatch()

  const history = useHistory()

  const user = useSelector((state: RootState) => state.auth.user)
  const userRole = user?.['custom:user_role']
  const userPlan = user?.['custom:user_plan']
  const isEmprendedorUser =
    userPlan === 'emprendedor' || userPlan === 'estudiantil'

  const onInvoiceSubscriber = async (subscriber: ISuscriber) => {
    try {
      console.log('onInvoiceSubscriber - subscriber:', subscriber)

      if (!subscriber?.subscriptions?.length) {
        addAlert({
          message: 'El suscriptor no tiene una suscripción activa',
          status: 'error',
          duration: 7000,
        })
        return
      }

      console.log(
        'onInvoiceSubscriber - subscriptionId:',
        subscriber.subscriptions[0].subscriptionId
      )

      // Verificar si la suscripción tiene items
      const subscriptionResponse = await axios.get(
        `${server}/subscription?id=${subscriber.subscriptions[0].subscriptionId}`
      )
      const subscription = subscriptionResponse.data.subscription

      console.log('onInvoiceSubscriber - subscription:', subscription)

      if (!subscription?.items || subscription.items.length === 0) {
        addAlert({
          message:
            'No se puede facturar una suscripción sin artículos o servicios asignados',
          status: 'error',
          duration: 7000,
        })
        return
      }

      const url = `/dashboard/suscripcion/facturar?clientId=${subscriber.clientId}&subscriptionId=${subscriber.subscriptions[0].subscriptionId}`
      console.log('onInvoiceSubscriber - navigating to:', url)

      history.push(url)
    } catch (error) {
      console.error('onInvoiceSubscriber - error:', error)
      addAlert({
        message: 'Error al verificar la suscripción',
        status: 'error',
        duration: 7000,
      })
    }
  }

  const onInvoiceWithProrate = async (subscriber: ISuscriber) => {
    try {
      console.log('onInvoiceWithProrate - subscriber:', subscriber)

      if (!subscriber?.subscriptions?.length) {
        addAlert({
          message: 'El suscriptor no tiene una suscripción activa',
          status: 'error',
          duration: 7000,
        })
        return
      }

      // Verificar si la suscripción tiene items
      const subscriptionResponse = await axios.get(
        `${server}/subscription?id=${subscriber.subscriptions[0].subscriptionId}`
      )
      const subscription = subscriptionResponse.data.subscription

      if (!subscription?.items || subscription.items.length === 0) {
        addAlert({
          message:
            'No se puede facturar una suscripción sin artículos o servicios asignados',
          status: 'error',
          duration: 7000,
        })
        return
      }

      // Abrir modal para solicitar días
      setSelectedClientForProrate(subscriber)
      setShowProrrateModal(true)
    } catch (error) {
      console.error('onInvoiceWithProrate - error:', error)
      addAlert({
        message: 'Error al verificar la suscripción',
        status: 'error',
        duration: 7000,
      })
    }
  }

  const onConfirmProrate = () => {
    const days = parseInt(prorrateDays)

    // Validar que sea un número válido entre 1 y 30
    if (isNaN(days) || days < 1 || days > 30) {
      addAlert({
        message: 'Por favor ingrese un número válido entre 1 y 30 días',
        status: 'error',
        duration: 5000,
      })
      return
    }

    // Calcular descuento con fórmula proporcional exacta: 100 - ((días / 30) × 100)
    const discount = 100 - (days / 30) * 100

    console.log(`Días: ${days}, Descuento calculado: ${discount.toFixed(2)}%`)

    // Cerrar modal
    setShowProrrateModal(false)
    setProrrateDays('')

    if (selectedClientForProrate) {
      const url = `/dashboard/suscripcion/facturar?clientId=${selectedClientForProrate.clientId}&subscriptionId=${selectedClientForProrate.subscriptions[0].subscriptionId}&discount=${discount}`
      console.log('onConfirmProrate - navigating to:', url)
      history.push(url)
    }

    setSelectedClientForProrate(null)
  }

  const onGetSubscribers = async (
    page: number = 0,
    searchParam: string = fastSearch,
    advancedParams: any = searchParams
  ) => {
    setLoading(true)
    setFastSearch(searchParam)
    setCurrentPage(page)
    setSearchParams(advancedParams)

    const params: any = {
      pageNumber: page + 1,
      pageSize: 10,
    }

    if (searchParam) {
      params.search = searchParam
    }

    // Agregar parámetros de búsqueda avanzada
    if (advancedParams.search) {
      params.search = advancedParams.search
    }

    if (advancedParams.expirationDate_from) {
      params.expirationDate_from = advancedParams.expirationDate_from
    }

    if (advancedParams.expirationDate_to) {
      params.expirationDate_to = advancedParams.expirationDate_to
    }

    const response = await axios.get<{
      clients: ISuscriber[]
      numberOfPages: number
    }>(`${server}/subscription/link-client`, { params })
    setSubscribers(response.data.clients)
    setNumberOfPages(response.data.numberOfPages)
    setLoading(false)
  }

  const onGetSuscriptions = async () => {
    const response = await axios.get<{
      subscriptions: ISuscription[]
    }>(`${server}/subscription`)
    setSuscriptions(response.data.subscriptions)
  }

  useEffect(() => {
    // No cargar datos si es plan emprendedor
    if (!isEmprendedorUser) {
      onGetSubscribers()
      onGetSuscriptions()
    }
  }, [isEmprendedorUser])

  const columns: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Documento',
      dataIndex: 'document',
      key: 'document',
      render: (x: any, row) => {
        console.log('row', row)
        return (
          <ColumnItemWrapper subElement="paragraph">
            {row?.documentType}-{row?.document}
          </ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Descripción de la suscripción',
      dataIndex: 'description',
      key: 'description',
      render: (_: any, row) => {
        return (
          <ColumnItemWrapper subElement="paragraph">
            {row?.subscriptions?.length > 0
              ? row?.subscriptions[0]?.description
              : 'N/A'}
          </ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Fecha de inicio de la suscripción',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (_: any, row) => {
        return (
          <ColumnItemWrapper subElement="paragraph">
            {row?.subscriptions?.length > 0
              ? transformDate(row?.subscriptions[0]?.startDate)
              : 'N/A'}
          </ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Fecha fin de la suscripción',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (_: any, row) => {
        return (
          <ColumnItemWrapper subElement="paragraph">
            {row?.subscriptions?.length > 0
              ? transformDate(row?.subscriptions[0]?.endDate)
              : 'N/A'}
          </ColumnItemWrapper>
        )
      },
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, client) => (
        <ColumnItemWrapper floatingMenu>
          <FloatingMenu
            visible={client?.clientId === menuVisible}
            onClose={() => setMenuVisible(-1)}
            options={{
              onCustomButtons: [
                {
                  title: 'Ver',
                  action: () => {
                    setSelectedSubscriberToView(client)
                    setShowViewModal(true)
                    setMenuVisible(-1)
                  },
                  display: true,
                  icon: <FiEye size={18} className="text-primary" />,
                  color: 'text-primary',
                },
                {
                  title: 'Facturar',
                  action: () => {
                    onInvoiceSubscriber(client)
                    setMenuVisible(-1)
                  },
                  display: true,
                  icon: (
                    <IoReceiptOutline size={18} className="text-green-600" />
                  ),
                  color: 'text-green-600',
                },
                {
                  title: 'Fact. prorrateo',
                  action: () => {
                    onInvoiceWithProrate(client)
                    setMenuVisible(-1)
                  },
                  display: true,
                  icon: (
                    <IoCalculatorOutline
                      size={18}
                      className="text-orange-600"
                    />
                  ),
                  color: 'text-orange-600',
                },
                {
                  title: 'Editar',
                  action: () => {
                    setSuscriptionModal(true)
                    setSelectedSuscriberToEdit(client?.subscriptions[0])
                    setSelectedClient(client)
                    setMenuVisible(-1)
                  },
                  display: userRole !== 'cashier',
                  icon: <FiEdit size={18} className="text-primary" />,
                  color: 'text-primary',
                },
                {
                  title: 'Eliminar',
                  action: () => {
                    setSelectedSubscriptionToDelete(
                      client?.subscriptions[0]?.subscriptionId
                    )
                    setSelectedClientToDelete(client?.clientId)
                    setShowConfirmModal(true)
                    setMenuVisible(-1)
                  },
                  display: userRole !== 'cashier',
                  icon: <FiTrash2 size={18} className="text-red-600" />,
                  color: 'text-red-600',
                },
              ],
            }}
          >
            <HiDotsVertical
              className="cursor-pointer text-gray-400"
              onClick={() => {
                setMenuVisible(client?.clientId)
              }}
            />
          </FloatingMenu>
        </ColumnItemWrapper>
      ),
    },
  ]

  useEffect(() => {
    // No mostrar acciones si es plan emprendedor
    if (isEmprendedorUser) {
      setHeaderActions({})
    } else {
      setHeaderActions({
        addAction: () => {
          setShowModal(true)
        },
        advancedSearch: async (value) => {
          if (typeof value === 'boolean') {
            setModalSearch(value)
            return
          }
          onGetSubscribers(0, value, {})
        },
        onCustomAction: [
          {
            title: 'Exportar',
            icon: <HiDownload />,
            buttonType: 'outline',
            action: () => onExportToExcel(),
            display: true,
            tooltipMessage: 'Exportar a Excel',
          },
        ],
        cleanFilters: {
          sort: () => {},
          search: async () => {
            setFastSearch('')
            setSearchParams({})
            onGetSubscribers(0, '', {})
          },
          isSort: false,
          isSearch: Boolean(fastSearch) || Object.keys(searchParams).length > 0,
        },
      })
    }
    return () => setHeaderActions(null)
  }, [setHeaderActions, fastSearch, searchParams, userRole, isEmprendedorUser])

  const onHandlecreateClient = async (values) => {
    const _values: { client: Omit<IClient, 'id'> } = values

    setLoading(true)
    try {
      addAlert({ message: 'Creando cliente...', status: 'loading' })

      // let response : any = await dispatch(createClient(_values))

      const response = await axios.post(`${server}/thirdparty/client`, _values)

      console.log('ESTE ES EL RESPONSE', response)

      addAlert({ message: 'Cliente creado con éxito', status: 'success' })
      setSuscriptionModal(true)
      setSelectedClient(response.data.client)
    } catch (e) {
      addAlert({
        message: 'Error al crear cliente',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const onExportToExcel = async () => {
    try {
      addAlert({ message: 'Generando reporte...', status: 'loading' })

      const params: any = {
        pageNumber: 1,
        pageSize: 5000,
      }

      // Agregar parámetros de búsqueda si existen
      if (fastSearch) {
        params.search = fastSearch
      }

      if (searchParams.search) {
        params.search = searchParams.search
      }

      if (searchParams.expirationDate_from) {
        params.expirationDate_from = searchParams.expirationDate_from
      }

      if (searchParams.expirationDate_to) {
        params.expirationDate_to = searchParams.expirationDate_to
      }

      const response = await axios.get<{
        clients: ISuscriber[]
        numberOfPages: number
      }>(`${server}/subscription/link-client`, { params })

      // Formatear datos para Excel
      const excelData = response.data.clients.map((subscriber) => [
        subscriber.name || 'N/A',
        `${subscriber.documentType || ''}-${subscriber.document || ''}`,
        subscriber.subscriptions?.length > 0
          ? subscriber.subscriptions[0]?.description || 'N/A'
          : 'N/A',
        subscriber.subscriptions?.length > 0
          ? transformDate(subscriber.subscriptions[0]?.startDate) || 'N/A'
          : 'N/A',
        subscriber.subscriptions?.length > 0
          ? transformDate(subscriber.subscriptions[0]?.endDate) || 'N/A'
          : 'N/A',
        subscriber.email || 'N/A',
        subscriber.phone || 'N/A',
      ])

      await onCreateSubscribersExcel({ data: excelData })

      addAlert({ message: 'Reporte generado exitosamente', status: 'success' })
    } catch (error) {
      console.error('Error al exportar:', error)
      addAlert({
        message: 'Error al generar el reporte',
        status: 'error',
      })
    }
  }

  const onCreateSuscription = async (values: any): Promise<void> => {
    const body = {
      chargeDay: +values.duration,
      endDate: dateToDB(values.endDate),
      startDate: dateToDB(values.startDate),
      clientId: selectedClient?.id || '',
      subscriptionId: +values.subscription,
    }
    try {
      setCreatingSuscriber(true)
      // setLoadingSubscriber(true)
      addAlert({
        message: selectedSuscriberToEdit
          ? 'Editando suscriptor...'
          : 'Creando suscriptor...',
        status: 'loading',
      })
      if (selectedSuscriberToEdit) {
        await axios.patch(`${server}/subscription/link-client`, {
          ...body,
          clientId: selectedClient?.clientId,
        })
      } else {
        await axios.post(`${server}/subscription/link-client`, body)
      }
      await onGetSubscribers(currentPage, fastSearch)
      setSuscriptionModal(false)
      setShowModal(false)
      addAlert({
        message: selectedSuscriberToEdit
          ? 'Suscriptor editado satisfactoriamente'
          : 'Suscriptor creado satisfactoriamente',
        status: 'success',
      })
    } catch (err) {
      addAlert({
        message: selectedSuscriberToEdit
          ? 'Error al editar suscriptor'
          : 'Error al crear suscriptor',
        status: 'error',
      })
    } finally {
      setCreatingSuscriber(false)
    }
  }

  // Mostrar mensaje de upgrade si es plan emprendedor
  if (isEmprendedorUser) {
    return (
      <div className="flex flex-col justify-center items-center h-full p-4">
        <div
          className="p-8 rounded-lg shadow-lg max-w-2xl text-center"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="mb-6">
            <MdPeople
              className="mx-auto mb-4"
              size={64}
              style={{ color: '#507CDC' }}
            />
          </div>
          <h2 className="text-2xl font-bold mb-4 dark:text-white">
            Funcionalidad Premium
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
            Para gestionar suscriptores debes mejorar tu plan a{' '}
            <strong className="text-primary">"PYME"</strong>
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-500">
            El plan Corporativo incluye gestión completa de suscriptores,
            seguimiento de estados, facturación automática, notificaciones y
            mucho más.
          </p>
        </div>
      </div>
    )
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Table
        data={subscribers}
        columns={columns}
        pages={numberOfPages}
        pageSelected={currentPage}
        loading={loading}
        setPageSelected={(page) => {
          onGetSubscribers(page, fastSearch)
        }}
        setLoading={setLoading}
      />

      <Modal
        display={showModal}
        // modalClasses="w-3/6 py-4 px-12"
        onClose={() => {
          setShowModal(false)
        }}
        scroll="scroll"
      >
        <ClientsForm
          onCancel={() => {
            setShowModal(false)
          }}
          useType="create"
          onSubmit={(values) => {
            console.log('values', values)
            onHandlecreateClient(values)
          }}
        />
      </Modal>

      <Modal
        display={suscriptionModal}
        // modalClasses="w-3/6 py-4 px-12"
        onClose={() => {
          setSuscriptionModal(false)
        }}
        scroll="scroll"
      >
        <SuscriberForm
          clientName={selectedClient?.name || ''}
          suscriptions={suscriptions}
          onSubmit={(values) => {
            onCreateSuscription(values)
          }}
          defaultValues={selectedSuscriberToEdit}
          isLoadingForm={creatingSuscriber}
          onCancel={() => {
            setSelectedSuscriberToEdit(null)
            setSuscriptionModal(false)
            setSelectedClient(null)
          }}
        />
      </Modal>

      <ModalConfirm
        title="¿Está seguro que desea eliminar este suscriptor?"
        displayConfirmModal={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={async () => {
          addAlert({
            message: 'Eliminando suscriptor...',
            status: 'loading',
          })
          try {
            await axios.delete(
              `${server}/subscription/link-client?clientId=${selectedClientToDelete}&subscriptionId=${selectedSubscriptionToDelete}`
            )
            await onGetSubscribers(currentPage, fastSearch)

            setShowConfirmModal(false)
            addAlert({
              message: 'Suscriptor eliminado satisfactoriamente',
              status: 'success',
            })
          } catch (error) {
            addAlert({
              message: 'Error al eliminar suscriptor',
              status: 'error',
            })
          } finally {
            setShowConfirmModal(false)
          }
        }}
      />

      <FloatingForm
        visible={modalSearch}
        onClose={() => setModalSearch(false)}
        topClass="top-20"
        rightClass="right-10"
        containerClass="w-2/6"
      >
        <AdvancedSubscribersForm
          onSubmit={(params: any) => {
            onGetSubscribers(0, '', params)
            setModalSearch(false)
          }}
          onCloseAdvancedForm={() => setModalSearch(false)}
        />
      </FloatingForm>

      <Modal
        display={showProrrateModal}
        onClose={() => {
          setShowProrrateModal(false)
          setProrrateDays('')
          setSelectedClientForProrate(null)
        }}
        scroll="scroll"
      >
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Facturar con Prorrateo</h2>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            ¿Cuántos días de la suscripción se van a cobrar?
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-500 mb-6">
            Ingrese un número entre 1 y 30 días. El descuento se calculará
            automáticamente.
          </p>
          <div className="mb-6">
            <label className="block text-sm font-medium mb-2">
              Días a cobrar
            </label>
            <input
              type="number"
              min="1"
              max="30"
              value={prorrateDays}
              onChange={(e) => setProrrateDays(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:border-primary dark:bg-gray-800 dark:text-white"
              placeholder="Ej: 15"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onConfirmProrate()
                }
              }}
            />
            {prorrateDays &&
              parseInt(prorrateDays) >= 1 &&
              parseInt(prorrateDays) <= 30 && (
                <p className="text-xs text-primary mt-2">
                  Descuento calculado:{' '}
                  {(100 - (parseInt(prorrateDays) / 30) * 100).toFixed(2)}%
                </p>
              )}
          </div>
          <div className="flex justify-end gap-3">
            <button
              onClick={() => {
                setShowProrrateModal(false)
                setProrrateDays('')
                setSelectedClientForProrate(null)
              }}
              className="px-4 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirmProrate}
              className="px-4 py-2 text-sm bg-primary text-white rounded-lg hover:bg-primary-dark transition"
            >
              Continuar
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        display={showViewModal}
        onClose={() => {
          setShowViewModal(false)
          setSelectedSubscriberToView(null)
        }}
        scroll="scroll"
      >
        {selectedSubscriberToView && (
          <SubscriberView
            subscriber={selectedSubscriberToView}
            onClose={() => {
              setShowViewModal(false)
              setSelectedSubscriberToView(null)
            }}
          />
        )}
      </Modal>
    </motion.div>
  )
}

export default Suscribers
